import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';

import { hasPermission } from '@/entities/practice-member';

type BillingDocumentsBeforeLoadArgs = {
    context: { queryClient: QueryClient };
};

export async function billingDocumentsBeforeLoad({ context }: BillingDocumentsBeforeLoadArgs) {
    if (!(await hasPermission(context.queryClient, ['CLINICIAN', 'EHR_BASE']))) {
        throw redirect({ to: '/settings/profile' });
    }
}
